import request from "@/utils/request";

// 列表(主数据列表)
export function loadRetailMonitoringProductSettingListDataApi(data) {
    return request({
      url: "web/retailMonitoringProductSetting/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadRetailMonitoringProductSettingExportDataApi(data) {
    return request({
      url: "web/retailMonitoringProductSetting/exportData",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateRetailMonitoringProductSettingApi(data) {
    return request({
      url: "web/retailMonitoringProductSetting/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initRetailMonitoringProductSettingApi(data) {
    return request({
      url: "web/retailMonitoringProductSetting/init",
      method: "post",
      data
    });
  }
  
  // 根据城市ID获取零售监测调查品规设置
  export function findRetailMonitoringProductByCityIdApi(data) {
    return request({
      url: "web/retailMonitoringProductSetting/findSettingProductDataByCityId",
      method: "post",
      data
    });
  }
  
  // 更新采集零售户零售监测采集品规设置
  export function updateCollectStoreInfoMonitorProductApi(data) {
    return request({
      url: "web/retailMonitoringProductSetting/updateCollectStoreInfoMonitorProduct",
      method: "post",
      data
    });
  }
  